import { createGlobalStyle, ThemeProvider } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  .ant-input {
    height: 40px; /* Thay đổi giá trị này theo ý muốn của bạn */
    border-width: 0px 0px 1px 0px !important;;
  }
  .ant-input-disabled {
    color: rgba(0, 0, 0, 0.88) !important;
    background-color: #ffffff !important;;
    border-width: 0px 0px 0px 0px !important;;
  }
  
  .ant-select-selection-item {
    color: rgba(0, 0, 0, 0.88) !important
  }

  .ant-picker {
    height: 40px; /* Thay đổi giá trị này theo ý muốn của bạn */
    border-width: 0px 0px 1px 0px !important;
  }
  .ant-picker-disabled {
    background-color: #ffffff !important;;
    border-width: 0px 0px 0px 0px !important;
    input {
      color: rgba(0, 0, 0, 0.88) !important;
    }
  }
  .ant-select {
    height: 40px; /* Thay đổi giá trị này theo ý muốn của bạn */
  }

  .ant-btn-link {
    margin-left: 5px;
    margin-right: 5px;
  }
  .ant-btn {
    margin-left: 2px;
    margin-right: 2px;
  }
  .card-search {
    .ant-btn {
      height: 40px;
    }
  }
`;

export const customTheme = {
  token: {
    fontFamily: "Roboto, sans-serif", // Thay thế bằng font bạn muốn
    // Navbar (.nav-header-top) z-index 1030 và sidebar (.ds-sidebar) 1040 đều
    // position:fixed, đè lên modal của antd (mặc định 1000). Nâng base để mọi
    // modal/drawer/dropdown nổi lên trên.
    zIndexPopupBase: 1100,
  },
};
